import { useContext, useMemo } from 'react'

import { isArray, isFunction } from 'lodash'

import { InstitutionContext } from '../../../../Providers/InstitutionProvider'
import { SchoolContext } from '../../../../Providers/SchoolProvider'
import { isObject } from '../../../../utils'
import EntitiesSelector from '../EntitiesSelector'
import EntityOptionLabel from '../EntityOptionLabel'
import { SchoolModalContext } from '../../../../Providers/Forms/SchoolModal'
import { getEntityRank } from '../../Badges/EntityBadge'

const getLabel = (school, reverse) => (reverse ? school.name : school.abbreviation ?? school.name) ?? ''

const getTooltip = (school, reverse) => reverse ? school.abbreviation ?? '' : school.name

/** Same flat listing as the institutions selector : the badged schools first, then the others. */
const SchoolsSelector = ({
  className = '', empty = false, disabled, schools = null, multiple = 'default', reverse = false, style = {}, values, dropdownRender, placeholder = '', onChange,
  renderOption, onSearch, loading
}) => {
  const ic = useContext(InstitutionContext)
  const sc = useContext(SchoolContext)
  const modalContext = useContext(SchoolModalContext)

  const schoolEntities = useMemo(() => {
    let schoolEntities = []

    if (isArray(schools)) {
      schoolEntities = schools
    } else if (isObject(ic)) {
      schoolEntities = ic.schools
    } else if (isObject(sc)) {
      schoolEntities = [sc.school]
    }

    return schoolEntities.filter(isObject).sort((a, b) => {
      const rankDiff = getEntityRank(a) - getEntityRank(b)

      if (rankDiff !== 0) {
        return rankDiff
      }

      return getLabel(a, reverse).localeCompare(getLabel(b, reverse))
    })
  }, [schools, ic, sc, reverse])

  const schoolsOptions = useMemo(() => schoolEntities.map(school => ({
    label: getLabel(school, reverse),
    value: school.id,
    tooltip: getTooltip(school, reverse),
    entity: school
  })), [schoolEntities, reverse])

  return (
    <div className={'flex-col w-100 ' + className}>
      <EntitiesSelector
        selectorClassName='entities-selector-custom'
        disabled={disabled}
        empty={empty}
        entityOptions={schoolsOptions}
        multiple={multiple}
        placeholder={placeholder}
        showSearch
        style={style}
        values={values}
        dropdownRender={modalContext !== undefined && isFunction(dropdownRender) ? dropdownRender(modalContext.setFormHandler) : undefined}
        loading={loading}
        onChange={onChange}
        onSearch={onSearch}
        renderOption={
          isFunction(renderOption)
            ? renderOption
            : school => <EntityOptionLabel entity={school} label={getLabel(school, reverse)} />
        }
      />
    </div>
  )
}

export default SchoolsSelector
